import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "15",
  viewBox: "0 0 16 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.25 7.5C14.25 10.9518 11.4518 13.75 8 13.75C4.54822 13.75 1.75 10.9518 1.75 7.5C1.75 4.04822 4.54822 1.25 8 1.25C11.4518 1.25 14.25 4.04822 14.25 7.5ZM15.5 7.5C15.5 11.6421 12.1421 15 8 15C3.85786 15 0.5 11.6421 0.5 7.5C0.5 3.35786 3.85786 0 8 0C12.1421 0 15.5 3.35786 15.5 7.5ZM8.625 4.16667C8.625 3.82149 8.34518 3.54167 8 3.54167C7.65482 3.54167 7.375 3.82149 7.375 4.16667V8.33333C7.375 8.67851 7.65482 8.95833 8 8.95833C8.34518 8.95833 8.625 8.67851 8.625 8.33333V4.16667ZM8.625 10.625C8.625 10.9702 8.34518 11.25 8 11.25C7.65482 11.25 7.375 10.9702 7.375 10.625C7.375 10.2798 7.65482 10 8 10C8.34518 10 8.625 10.2798 8.625 10.625Z",
  fill: "#D24827"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }